import Dashboard from '@material-ui/icons/Dashboard';
import HotTubIcon from '@material-ui/icons/HotTub';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import MapSharp from '@material-ui/icons/MapSharp';
import MergeTypeIcon from '@material-ui/icons/MergeType';
import SettingIcon from '@material-ui/icons/Settings'
// core components/views for Admin layout
import DashboardPage from './views/Dashboard/Dashboard.js';
import Orders from './views/CategoryTable/OrdersTableList.js';
import Discounts from './views/CategoryTable/Discounts.js';
import AdminSetting from './views/Setting/AdminSetting'
import DeliveryBoys from './views/DeliveryBoys/DeliveryBoysList.jsx';
import UsersList from './views/Users/UsersList';
import SMSList from './views/SMS/SMSList';
import TableListCategories from './views/CategoryTable/CategoryTableList.js';
import VendorsTable from './views/Vendor/VendorsTable.js';
import Circumstance from './views/Circumstance/Circumstance.js';
import RestaurantType from './views/RestaurantType/RestaurantType';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import Money from '@material-ui/icons/AttachMoney';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import PostalCode from './views/PostalCode/PostalCode.js';
import PersonIcon from '@material-ui/icons/Person';
import SmsIcon from '@material-ui/icons/Sms';
import EventIcon from '@material-ui/icons/Event';
import AllEvents from './views/CategoryTable/AllEvents.js';

const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    rtlName: 'لوحة القيادة',
    icon: Dashboard,
    component: DashboardPage,
    layout: '/admin',
  },
  {
    path: '/super-categories',
    name: 'All Super-Categories',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: LibraryBooksIcon,
    component: TableListCategories,
    layout: '/admin',
  },
  /*{
    path: "/allCategory2",
    name: "All Categories",
    rtlName: "",
    icon: ListAltIcon,
    component: CategoriesTable,
    layout: "/admin2"
  },
  {
    path: "/subCategories",
    name: "All Sub-Categories",
    rtlName: "طباعة",
    icon: DynamicFeedIcon,
    component: SubCategoriesTable,
    layout: "/admin2"
  },*/
  {
    path: '/vendors',
    name: 'All Vendors',
    rtlName: 'طباعة',
    icon: HotTubIcon,
    component: VendorsTable,
    layout: '/admin',
  },
  {
    path: '/delivery-boys',
    name: 'Delivery Boys',
    icon: DirectionsBikeIcon,
    component: DeliveryBoys,
    layout: '/admin',
  },
  {
    path: '/users',
    name: 'Users',
    icon: PersonIcon,
    component: UsersList,
    layout: '/admin',
  },
  {
    path: '/sms',
    name: 'Push SMS',
    icon: SmsIcon,
    component: SMSList,
    layout: '/admin',
  },
  {
    path: '/all-orders',
    name: 'All Orders',
    rtlName: '',
    icon: ListAltIcon,
    component: Orders,
    layout: '/admin',
  },
  {
    path: '/all-events',
    name: 'Events',
    rtlName: '',
    icon: EventIcon,
    component: AllEvents,
    layout: '/admin',
  },
  {
    path: '/discounts',
    name: 'Discounts',
    rtlName: '',
    icon: Money,
    component: Discounts,
    layout: '/admin',
  },
  {
    path: '/circumstance',
    name: 'Circumstances',
    rtlName: '',
    icon: MapSharp,
    component: Circumstance,
    layout: '/admin',
  },
  {
    path: '/restaurant-type',
    name: 'Restaurant Type',
    rtlName: '',
    icon: MergeTypeIcon,
    component: RestaurantType,
    layout: '/admin',
  },
  {
    path: '/postal-code',
    name: 'Postal Code',
    rtlName: '',
    icon: HomeOutlinedIcon,
    component: PostalCode,
    layout: '/admin',
  },
  {
    path: '/commission',
    name: 'Commission',
    rtlName: '',
    icon: SettingIcon,
    component: AdminSetting,
    layout: '/admin',
  },
  /*{
    path: "/icons",
    name: "Icons",
    rtlName: "الرموز",
    icon: BubbleChart,
    component: Icons,
    layout: "/admin2"
  },
  {
    path: "/maps",
    name: "Maps",
    rtlName: "خرائط",
    icon: LocationOn,
    component: Maps,
    layout: "/admin2"
  },
  {
    path: "/notifications",
    name: "Notifications",
    rtlName: "إخطارات",
    icon: Notifications,
    component: NotificationsPage,
    layout: "/admin2"
  }*/
];

export default dashboardRoutes;
